export default "__VITE_ASSET__DwFr3wkd__"